// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerA_banner__prTVd"};